<template>
  <section class="">
    <vue-headful title="ตอนล่าสุด" description="READ-THAI นิยายแปลไทย นิยายแฟนตาซี นิิยายแปล" />
    <div class="box">
      <keep-alive>
        <b-tabs type="is-toggle is-centered" v-model="menu">
          <b-tab-item label="25 ตอนล่าสุด" icon="fas fa-fire"></b-tab-item>
          <b-tab-item label="นิยายทั้งหมด" icon="fas fa-image"></b-tab-item>
          <b-tab-item label="ช่องทางสนับสนุน" icon="fas fa-dollar-sign"></b-tab-item>
          <b-tab-item v-show="readLatest.length > 0" label="อ่านล่าสุด" icon="fas fa-globe-asia"></b-tab-item>
        </b-tabs>
      </keep-alive>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      menu: this.menuIndex(this.$route.path)
    }
  },
  computed: {
    readLatest () {
      return localStorage.getItem('my_read') ? localStorage.getItem('my_read') : []
    }
  },
  methods: {
    menuIndex (path) {
      switch (path) {
        case '/': return 0
        case '/novels': return 1
        case '/donate': return 2
        case '/readed': return 3
        default: return 0
      }
    }
  },
  watch: {
    menu (value) {
      switch (value) {
        case 0: this.$router.push({ name: 'latest' })
          break
        case 1: this.$router.push({ name: 'novels' })
          break
        case 2: this.$router.push({ name: 'donate' })
          break
        case 3: this.$router.push({ name: 'readed' })
          break
        default: break
      }
    }
  }
}
</script>

<style>
  /* .home {
    list-style-type: none;
    margin: 10%;
  } */
</style>
